import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';

import Login from './pages/public/login/Login'
import Home from './pages/public/home/Home';
import About from './pages/public/about/About';
import ContactUs from './pages/public/contact/Contact';
import TermsAndCondition from './pages/public/terms-and-conditions/TermsAndConditions';
import OurServices from './pages/public/our-services/Services';

import ForgetPassword1 from './pages/public/forgot-password/ForgetPassword1';
import VerifyOTP from './pages/public/forgot-password/VerifyOTP';
import ResetPassword from './pages/public/forgot-password/ResetPassword';

import AdminDashboard from './pages/admin/dashboard/AdminDashboard';
import AdminDashboardHome from './pages/admin/dashboard/AdminDashboardHome';

import Staffs from './pages/admin/dashboard/tabs/staffs';
import CreateStaff from './pages/admin/dashboard/tabs/staffs/CreateStaff';
import EditStaff from './pages/admin/dashboard/tabs/staffs/EditStaff';

import Customers from './pages/admin/dashboard/tabs/customers';
import CreateCustomer from './pages/admin/dashboard/tabs/customers/CreateCustomer';
import EditCustomer from './pages/admin/dashboard/tabs/customers/EditCustomer';

// import CreditDebitAmount from './pages/admin/dashboard/tabs/transactions/CreditDebitAmount';
import AdminCreditDebit from './pages/admin/dashboard/tabs/transactions/CreditDebit';

import Transactions from './pages/admin/dashboard/tabs/transactions'
import Ticket from './pages/admin/dashboard/tabs/tickets';
import Setting from './pages/admin/dashboard/tabs/settings';

// finance imports 
import Loans from './pages/admin/dashboard/tabs/financials/loans';
import CreateLoan from './pages/admin/dashboard/tabs/financials/loans/CreateLoan';

import FDs from './pages/admin/dashboard/tabs/financials/fds';
import CreateFD from './pages/admin/dashboard/tabs/financials/fds/CreateFD';

import Insurance from './pages/admin/dashboard/tabs/financials/insurance';
import CreateInsurance from './pages/admin/dashboard/tabs/financials/insurance/CreateInsurance';

// print import
import PrintWrapper from './pages/admin/print/PrintWrapper';

// ============ Staff Dashboard imports =========
import StaffDashboard from './pages/staff/dashboard/StaffDashboard';
import StaffDashboardHome from './pages/staff/dashboard/StaffDashboardHome';
import StaffCreditDebit from './pages/staff/dashboard/tabs/transactions/CreditDebit';
import StaffTransactions from './pages/staff/dashboard/tabs/transactions';

// ============ User Dashboard imports =========
import UserDashboard from './pages/user/dashboard/UserDashboard'; 
import UserDashboardHome from './pages/user/dashboard/UserDashboardHome';
import Passbook from './pages/user/dashboard/tabs/Passbook';

import PrivateRoute from './components/PrivateRoute';
import { useAuth } from './context/AuthContext';

function App() {
    const { user } = useAuth(); // Access user from Auth context

    return (
        <BrowserRouter>
            <Routes>
                <Route path='/login' element={<Login />} />
                <Route path='/' element={<Home />} />
                <Route path='/about' element={<About />} />
                <Route path='/contact' element={<ContactUs />} />
                <Route path='/termsandconditions' element={<TermsAndCondition />} />
                <Route path='/our-services' element={<OurServices />} />

                {/* Admin Dashboard Routes */}
                <Route path='/admin-dashboard' element={<PrivateRoute requiredRole='admin' element={<AdminDashboard />} />}>
                  <Route index element={<PrivateRoute requiredRole='admin' element={<AdminDashboardHome />} />} />
            
                  <Route path="staffs">
                    <Route index element={<PrivateRoute requiredRole="admin" element={<Staffs />} />} />
                    <Route path="create" element={<PrivateRoute requiredRole="admin" element={<CreateStaff />} />} />
                    <Route path="edit/:id" element={<PrivateRoute requiredRole="admin" element={<EditStaff />} />} />
                  </Route>
            
                  <Route path="customers">
                    <Route index element={<PrivateRoute requiredRole="admin" element={<Customers />} />} />
                    <Route path="create" element={<PrivateRoute requiredRole="admin" element={<CreateCustomer />} />} />
                    <Route path="edit/:id" element={<PrivateRoute requiredRole="admin" element={<EditCustomer />} />} />
                  </Route>
                  <Route path='credit-debit' element={<PrivateRoute requiredRole='admin' element={<AdminCreditDebit />} />} />
                  <Route path='transactions' element={<PrivateRoute requiredRole='admin' element={<Transactions />} />} />
                  <Route path='tickets' element={<PrivateRoute requiredRole='admin' element={<Ticket />} />} />
                  <Route path='settings' element={<PrivateRoute requiredRole='admin' element={<Setting />} />} />
                  
                  {/* 🔥 FINANCIAL MODULES */}
                  
                    {/* LOANS */}
                    <Route path="loans">
                      <Route index element={<PrivateRoute requiredRole="admin" element={<Loans />} />} />
                      <Route path="create" element={<PrivateRoute requiredRole="admin" element={<CreateLoan />} />} />
                    </Route>
                  
                    {/* FDs */}
                    <Route path="fds">
                      <Route index element={<PrivateRoute requiredRole="admin" element={<FDs />} />} />
                      <Route path="create" element={<PrivateRoute requiredRole="admin" element={<CreateFD />} />} />
                    </Route>
                  
                    {/* INSURANCE */}
                    <Route path="insurance">
                      <Route index element={<PrivateRoute requiredRole="admin" element={<Insurance />} />} />
                      <Route path="create" element={<PrivateRoute requiredRole="admin" element={<CreateInsurance />} />} />
                    </Route>
                                
                </Route>
                
                {/* ✅ PRINT OUTSIDE */}
                <Route
                  path="/admin-dashboard/print"
                  element={<PrivateRoute requiredRole="admin" element={<PrintWrapper />} />}
                />
          
                {/* Staff Dashboard Route */}
          
                <Route path='/staff-dashboard' element={<PrivateRoute requiredRole='staff' element={<StaffDashboard />} />}>
                  <Route index element={<PrivateRoute requiredRole='staff' element={<StaffDashboardHome />} />} />
                  <Route path='credit-debit' element={<PrivateRoute requiredRole='staff' element={<StaffCreditDebit />} />} />
                  <Route path='transactions' element={<PrivateRoute requiredRole='staff' element={<StaffTransactions />} />} />
                </Route>
                
                {/* User Dashboard Route */}
                <Route path='/user-dashboard' element={<PrivateRoute requiredRole='customer' element={<UserDashboard />} />}>
                    <Route index element={<PrivateRoute requiredRole='customer' element={<UserDashboardHome />} />} />
                    <Route path='passbook' element={<PrivateRoute requiredRole='customer' element={<Passbook />} />} />
                </Route>

                {/* Password Recovery Routes */}
                <Route path="/forget-password" element={<ForgetPassword1 />} />
                <Route path="/verify-otp" element={<VerifyOTP />} />
                <Route path="/reset-password" element={<ResetPassword />} />

            </Routes>
        </BrowserRouter>
    );
}

export default App;
